<template>
	<div class="figure-box">
		<Breadcrumb :crumb="crumb"></Breadcrumb>
		<div class="figure" v-if="form_data">
			<div class="left">
				<div class="item-box">
					<div class="title">个人信息</div>
					<div class="input-item-box">
						<div class="input-item">
							<div class="name">姓名</div>
							<input placeholder="请输入您的姓名" v-model="form_data.name" />
						</div>
						<div class="input-item">
							<div class="name">性别</div>
							<div class="radio-box" style="line-height: 42px;">
								<Radio-group v-model="form_data.sex">
									<Radio :label="1">
										<span>男</span>
									</Radio>
									<Radio :label="2">
										<span>女</span>
									</Radio>
								</Radio-group>
							</div>
						</div>
						<div class="input-item">
							<div class="name">生日</div>
							<date-picker
									v-model="form_data.birthday"
									type="date"
									value-type="format"
									format="YYYY-MM-DD"
									:editable="false"
									:clearable="false"
									input-class="ub-input"
									placeholder="请选择您的生日"
							></date-picker>
						</div>
					</div>
					<div class="input-item-box">
						<div class="input-item">
							<div class="name">手机</div>
							<input placeholder="请输入您的手机号" v-model="form_data.mobile" />
						</div>
						<div class="input-item">
							<div class="name">身高</div>
							<input placeholder="请输入您的身高（厘米）" v-model="form_data.height" />
						</div>
						<div class="input-item">
							<div class="name">体重</div>
							<input placeholder="请输入您的体重（公斤）" v-model="form_data.weight" />
						</div>
					</div>
					<div class="input-item-box">
						<div class="input-item" style="margin-bottom: 10px;">
							<div class="name">穿衣偏好</div>
							<Radio-group v-model="form_data.clothes_preference" style="margin-left:20px">
								<Radio :label="2">
									<span>紧身版</span>
								</Radio>
								<Radio :label="1">
									<span>合体版</span>
								</Radio>
								<Radio :label="4">
									<span>标准版</span>
								</Radio>
								<Radio :label="3">
									<span>宽松版</span>
								</Radio>
							</Radio-group>
						</div>
					</div>
					<div class="input-item-box">
						<div class="input-item" style="margin-bottom: 10px;">
							<div class="name">参考体型</div>
							<template v-if="form_data.sex == 1">
								<Radio-group v-model="form_data.somatotype" style="margin-left:20px">
									<Radio label="Y">
										<span>Y型</span>
									</Radio>
									<Radio label="A">
										<span>A型</span>
									</Radio>
									<Radio label="B">
										<span>B型</span>
									</Radio>
									<Radio label="C">
										<span>C型</span>
									</Radio>
									<Radio label="D">
										<span>D型</span>
									</Radio>
									<Radio label="E">
										<span>E型</span>
									</Radio>
									<Radio label="T">
										<span>T型</span>
									</Radio>
								</Radio-group>
							</template>
							<template v-else>
								<Radio-group v-model="form_data.somatotype" style="margin-left:20px">
									<Radio label="Y">
										<span>Y型</span>
									</Radio>
									<Radio label="A">
										<span>A型</span>
									</Radio>
									<Radio label="S">
										<span>S型</span>
									</Radio>
									<Radio label="H">
										<span>H型</span>
									</Radio>
								</Radio-group>
							</template>
						</div>
					</div>
				</div>

				<div class="item-box">
					<div class="title">
						量体信息
						<span class="text-333 margin-left-20 text-normal"
							style="font-size: 12px;">{{ form_data.measure_type | get_mtm_measure_type }}</span>
					</div>
					<div class="table-wrap">
						<div class="input-box" v-for="(item, key) in figureData" :key="'title'+key">
							<div class="input-title">{{item.field_name_cn}}</div>
							<input class="input" v-if="form_data.measure_type == 1" type="text" v-model="form_data.figure_body.net_size[item.field_key]" />
							<input class="input" v-if="form_data.measure_type == 2" type="text" v-model="form_data.figure_body.finish_size[item.field_key]" />
						</div>
						<div class="clear"></div>
					</div>
				</div>

				<div class="item-box">
					<div class="title">体态特征</div>
					<div class="body-box">
						<div class="body-item" v-for="(item,index) in bodyData" :key="index">
							<div class="name">{{ item.field_name_cn }}</div>
							<div class="img-list">
								<div class="img-box" @click="changeBody(item.field_key,oitem.text)"
									v-for="(oitem,oindex) in item.option_list" :key="oindex"
									:class="isActiveBody(item.field_key,oitem.text) ? 'select-active':''">
									<img :src="oitem.image" />
									<div class="value"> {{ oitem.text }} </div>
								</div>
								<div class="clear"></div>
							</div>
						</div>
						<div class="clear"></div>
					</div>

				</div>
				<div class="item-box">
					<div class="title">个人照片</div>
					<div class="flex align-center" style="padding: 20px 0;">
						<div class="upload-list">
							<div class="profile-image-wrap"  v-for="(url,index) in form_data.image" :key="'profile-img-' + index"  >
								<Icon type="ios-close-circle" class="profile-image-icon" @click="remove_image(index)" />
								<img :src="url" style="width: 100px;height: 100px;" />
							</div>

						</div>
						<Upload ref="upload" :show-upload-list="false" :on-success="handleSuccess"
							:format="['jpg','jpeg','png']" :max-size="2048" :on-format-error="handleFormatError"
							:on-exceeded-size="handleMaxSize" :before-upload="handleBeforeUpload" multiple
							:action="uploadHost" :data="uploadData" style="display: inline-block;">
							<img src="../../../assets/images/design/add@2x.png" style="width: 100px;" />

						</Upload>
					</div>


				</div>
				<div class="item-box">
					<div class="title">个人备注</div>
					<textarea placeholder="请写上您的备注" v-model="form_data.remark"></textarea>

				</div>
			</div>
			<div class="right">
				<div class="title">量体数据</div>
				<div class="order">
					<div class="main-color">量体信息</div>
					<div class="item" v-for="(item,index) in figureData" :key="index">
						<span>{{ item.field_name_cn }}</span>
						<span class="value">{{ getFigureValue(item.field_key) }} cm</span>
					</div>
					<div class="main-color">体态特征</div>
					<div class="item" v-for="item in bodyData" :key="item.name">
						<span>{{ item.field_name_cn }}</span>
						<span class="value">{{ getBodyValue(item.field_key) || '未选择'}}</span>
					</div>
				</div>
				<div class="save" @click="save">保存量体数据</div>
			</div>
			<div class="clear"></div>
		</div>
	</div>

</template>

<script>
	import C from '@/utils/rule/constant'
	import Breadcrumb from "@/components/Breadcrumb.vue";
	import axios from 'axios'
	import {
		getFigure,
		getBodyMeta,
		getFigureMeta,
		getMtmSetting,
		saveFigure
	} from "@/api"
	import {
		oss
	} from '@/utils/aliyunoss.js'
	import DatePicker from 'vue2-datepicker';
	import 'vue2-datepicker/index.css';
	import 'vue2-datepicker/locale/zh-cn';
	export default {
		name: "FBForm",
		components: {
			Breadcrumb,
			DatePicker
		},
		data() {
			return {
				crumb: [{
					title: "添加数据",
					path: "BodyEdit",
				}, ],
				uploadHost: '',
				uploadData: {},
				figureData: [],
				bodyData: [],
				settingData: [],
				form_data: {
					id: 0,
					birthday: "",
					name: "",
					mobile: "",
					sex: 1,
					height: "",
					weight: "",
					clothes_preference: 1,
					measure_type: 1,
					type: 1,
					somatotype: '',
					figure_body: {
						net_size: {},
						plus_size: {},
						finish_size: {},
						body_feature: {},
					},
					image: [],
					remark: "",
				},
			};
		},
		watch: {
			'form_data.height': function (newVal, oldVal) {
				this.calculator_soma()
			},
			'form_data.weight': function (newVal, oldVal) {
				this.calculator_soma()
			},
		},
		created() {
			if (this.$route.query.id) {
				this.id = this.$route.query.id
				this.crumb = [{
					title: "编辑数据",
					path: "BodyEdit",
				}, ]
				this.get()
			}
			this.getData()
		},

		methods: {
			setDefaultSomatotype(s) {
				this.form_data.somatotype = s
			},
			calculator_soma() {
				let height = this.form_data.height > 0 ? this.form_data.height : 1
				let weight = this.form_data.weight
				let bmi = weight * 10000 / (height * height)
				if(Math.abs(height - 155) <= 2.5) {
					if(bmi <= 18) {
						this.setDefaultSomatotype(C.SOMATOTYPE_Y)
					} else if(bmi <= 22.5) {
						this.setDefaultSomatotype(C.SOMATOTYPE_A)
					} else if(bmi <= 27) {
						this.setDefaultSomatotype(C.SOMATOTYPE_B)
					} else if(bmi <= 30) {
						this.setDefaultSomatotype(C.SOMATOTYPE_C)
					}  else if(bmi <= 34) {
						this.setDefaultSomatotype(C.SOMATOTYPE_CD)
					} else {
						this.setDefaultSomatotype(C.SOMATOTYPE_D)
					}
				} else if(Math.abs(height - 160) <= 2.5) {
					if(bmi <= 18.5) {
						this.setDefaultSomatotype(C.SOMATOTYPE_Y)
					} else if(bmi <= 23) {
						this.setDefaultSomatotype(C.SOMATOTYPE_A)
					} else if(bmi <= 27) {
						this.setDefaultSomatotype(C.SOMATOTYPE_B)
					} else if(bmi <= 30.5) {
						this.setDefaultSomatotype(C.SOMATOTYPE_C)
					}  else if(bmi <= 34.5) {
						this.setDefaultSomatotype(C.SOMATOTYPE_CD)
					} else {
						this.setDefaultSomatotype(C.SOMATOTYPE_D)
					}
				} else if(Math.abs(height - 165) <= 2.5) {
					if(bmi <= 18.5) {
						this.setDefaultSomatotype(C.SOMATOTYPE_Y)
					} else if(bmi <= 23) {
						this.setDefaultSomatotype(C.SOMATOTYPE_A)
					} else if(bmi <= 28) {
						this.setDefaultSomatotype(C.SOMATOTYPE_B)
					} else if(bmi <= 30.5) {
						this.setDefaultSomatotype(C.SOMATOTYPE_C)
					}  else if(bmi <= 34.5) {
						this.setDefaultSomatotype(C.SOMATOTYPE_CD)
					} else {
						this.setDefaultSomatotype(C.SOMATOTYPE_D)
					}
				} else if(Math.abs(height - 170) <= 2.5) {
					if(bmi <= 18.5) {
						this.setDefaultSomatotype(C.SOMATOTYPE_Y)
					} else if(bmi <= 23) {
						this.setDefaultSomatotype(C.SOMATOTYPE_A)
					} else if(bmi <= 28) {
						this.setDefaultSomatotype(C.SOMATOTYPE_B)
					} else if(bmi <= 30.5) {
						this.setDefaultSomatotype(C.SOMATOTYPE_C)
					}  else if(bmi <= 34.5) {
						this.setDefaultSomatotype(C.SOMATOTYPE_CD)
					} else {
						this.setDefaultSomatotype(C.SOMATOTYPE_D)
					}
				} else if(Math.abs(height - 175) <= 2.5) {
					if(bmi <= 19) {
						this.setDefaultSomatotype(C.SOMATOTYPE_Y)
					} else if(bmi <= 23) {
						this.setDefaultSomatotype(C.SOMATOTYPE_A)
					} else if(bmi <= 28) {
						this.setDefaultSomatotype(C.SOMATOTYPE_B)
					} else if(bmi <= 30.5) {
						this.setDefaultSomatotype(C.SOMATOTYPE_C)
					}  else if(bmi <= 34.5) {
						this.setDefaultSomatotype(C.SOMATOTYPE_CD)
					} else {
						this.setDefaultSomatotype(C.SOMATOTYPE_D)
					}
				} else if(Math.abs(height - 180) <= 2.5) {
					if(bmi <= 19.5) {
						this.setDefaultSomatotype(C.SOMATOTYPE_Y)
					} else if(bmi <= 24) {
						this.setDefaultSomatotype(C.SOMATOTYPE_A)
					} else if(bmi <= 28.5) {
						this.setDefaultSomatotype(C.SOMATOTYPE_B)
					} else if(bmi <= 31) {
						this.setDefaultSomatotype(C.SOMATOTYPE_C)
					}  else if(bmi <= 35) {
						this.setDefaultSomatotype(C.SOMATOTYPE_CD)
					} else {
						this.setDefaultSomatotype(C.SOMATOTYPE_D)
					}
				} else if(Math.abs(height - 185) <= 2.5) {
					if(bmi <= 19.5) {
						this.setDefaultSomatotype(C.SOMATOTYPE_Y)
					} else if(bmi <= 24) {
						this.setDefaultSomatotype(C.SOMATOTYPE_A)
					} else if(bmi <= 28.5) {
						this.setDefaultSomatotype(C.SOMATOTYPE_B)
					} else if(bmi <= 31) {
						this.setDefaultSomatotype(C.SOMATOTYPE_C)
					}  else if(bmi <= 35) {
						this.setDefaultSomatotype(C.SOMATOTYPE_CD)
					} else {
						this.setDefaultSomatotype(C.SOMATOTYPE_D)
					}
				} else if(Math.abs(height - 190) <= 2.5) {
					if(bmi <= 19.5) {
						this.setDefaultSomatotype(C.SOMATOTYPE_Y)
					} else if(bmi <= 24) {
						this.setDefaultSomatotype(C.SOMATOTYPE_A)
					} else if(bmi <= 28.5) {
						this.setDefaultSomatotype(C.SOMATOTYPE_B)
					} else if(bmi <= 31) {
						this.setDefaultSomatotype(C.SOMATOTYPE_C)
					}  else if(bmi <= 35) {
						this.setDefaultSomatotype(C.SOMATOTYPE_CD)
					} else {
						this.setDefaultSomatotype(C.SOMATOTYPE_D)
					}
				} else {
					if(bmi <= 18.5) {
						this.setDefaultSomatotype(C.SOMATOTYPE_Y)
					} else if(bmi <= 23) {
						this.setDefaultSomatotype(C.SOMATOTYPE_A)
					} else if(bmi <= 26) {
						this.setDefaultSomatotype(C.SOMATOTYPE_B)
					} else if(bmi <= 29) {
						this.setDefaultSomatotype(C.SOMATOTYPE_C)
					} else {
						this.setDefaultSomatotype(C.SOMATOTYPE_D)
					}
				}
			},
			async getData() {
				axios.all([
						getBodyMeta(), getFigureMeta(), getMtmSetting({field: 'common_body'})
				]).then(axios.spread((response1, response2, response3) => {
					this.figureData = response2.data
					let arr = response3.data.common_body.map(v=>v.field_key)
					for (let k in  response1.data) {
						console.log(333, response1.data[k])
						if(arr.includes(response1.data[k].field_key)) {
							this.bodyData.push(response1.data[k])
						}
					}
				}))
			},
			async get() {
				getFigure({
					id: this.id
				}).then((response1) => {
					this.form_data = response1.data
				})
			},
			async save() {
				let json = await saveFigure(this.form_data)
				if(json.code == 0) {
					this.$Notice.success({
						title: '保存成功',
					})
					setTimeout(()=> {
						this.$router.back();
					}, 1000)

				}
			},
			getFigureValue(key) {

				if (this.form_data.measure_type == 2) {
					return this.form_data.figure_body.finish_size[key]
				}
				return this.form_data.figure_body.net_size[key]
			},
			getBodyValue(key) {
				return this.form_data.figure_body.body_feature[key]
			},
			isActiveBody(field_key, text) {
				if (this.form_data.figure_body.body_feature[field_key] == text) {
					return true
				}
				return false
			},
			changeBody(field_key, text) {
				this.form_data.figure_body.body_feature[field_key] = text
				this.$forceUpdate()
			},
			remove_image(index) {
				this.form_data.image.splice(index, 1)
			},
			handleSuccess(res, file) {

				this.form_data.image.push(this.uploadData.oss_url + this.uploadData.dir + file.name)
			},
			handleFormatError(file) {
				this.$Notice.warning({
					title: '文件格式不正确',
					desc: '文件 ' + file.name + ' 格式不正确，请上传 jpg 或 png 格式的图片。'
				});
			},
			handleMaxSize(file) {
				this.$Notice.warning({
					title: '超出文件大小限制',
					desc: '文件 ' + file.name + ' 太大，不能超过 2M。'
				});
			},
			handleBeforeUpload(file) {
				//console.log(file,"file.name")
				return oss(file.name).then(res => {
					this.uploadHost = res.host
					this.uploadData = res
				})
			}
		},
	};
</script>

<style scoped lang="scss">
	.figure-box {
		width: 1170px;
		margin: 20px auto;
	}

	.figure {
		margin-top: 20px;
		margin-bottom: 50px;
	}

	.left {
		float: left;

		.item-box {
			width: 870px;
			background: #ffffff;
			box-shadow: 0px 2px 23px rgba(0, 0, 0, 0.07);
			border-radius: 5px;
			padding: 0 20px;
			margin-bottom: 20px;

			.body-box {
				margin: 20px 0;

				.body-item {
					display: flex;
					width: 800px;
					align-items: center;
					margin-bottom: 10px;

					.name {
						width: 68px;
						font-size: 14px;
						font-weight: bold;
						line-height: 59px;
					}

					.img-list {
						display: flex;
						.img-box {
							text-align: center;
							margin-left: 12px;

							img {
								width: 100px;
								height: 100px;
								border-radius: 7px;
							}

							.value {
								font-size: 12px;
								font-weight: 400;
								color: #000000;
								margin-top: 5px;
							}
						}
					}
				}
			}

			textarea {
				height: 80px;
				background: #F3F4F5;
				opacity: 1;
				border-radius: 5px;
				padding: 10px;
				width: 100%;
				border: none;
				margin: 20px 0;
			}

			.title {
				height: 52px;
				line-height: 52px;
				border-bottom: 1px solid #e9e9e9;
				color: #0f114a;
				font-size: 16px;
				font-weight: bold;
			}

			.input-item-box {
				margin-top: 20px;
				display: flex;
				height: 42px;

				.input-item {
					display: flex;
					align-items: center;
				}

				.name {
					font-size: 15px;
					font-weight: bold;
					color: #000000;
					min-width: 30px;
				}

				.radio-box,
				::v-deep .ub-input,
				input {
					width: 214px;
					height: 42px;
					border-bottom: 1px solid #dddddd;
					border-top: none;
					border-left: none;
					border-right: none;
					margin: 0 20px;
					padding-left: 10px;
				}
			}
		}
	}

	.right {
		margin-left: 30px;
		width: 270px;
		background: #ffffff;
		box-shadow: 0px 2px 23px rgba(0, 0, 0, 0.07);
		padding: 0 20px;
		float: left;

		.title {
			font-size: 16px;
			font-family: PingFang SC;
			font-weight: bold;
			line-height: 22px;
			color: #000000;
			height: 52px;
			line-height: 52px;
			border-bottom: 1px solid #e9e9e9;
			text-align: center;
		}

		.goods {
			padding-top: 10px;
			display: flex;

			img {
				width: 80px;
				height: 80px;
			}

			.content {
				margin-left: 10px;

				.p-name {
					font-size: 15px;
					font-weight: bold;
					color: #000000;
					height: 60px;
				}

				.number-box {
					height: 20px;
					border: 1px solid #999999;
					display: flex;
					align-items: center;

					.minus,
					.plus {
						width: 27px;
						cursor: pointer;
						color: #707070;
						line-height: 27px;
						text-align: center;
						font-size: 18px;
					}

					.num {
						border-top: none;
						border-bottom: none;
						border-left: 1px solid #999999;
						border-right: 1px solid #999999;
						width: 27px;
						text-align: center;
						color: #000000;
					}
				}
			}
		}

		.order {
			padding-bottom: 10px;

			.main-color {
				font-size: 16px;
				font-weight: bold;
				color: #0f114a;
				margin: 20px 0 10px;
			}

			.item {
				display: flex;
				justify-content: space-between;
				align-items: center;
				border-bottom: 1px solid #dddddd;
				height: 44px;

				span {
					font-size: 13px;
					font-weight: bold;
					color: #333333;
				}

				.value {
					font-weight: 400;
					color: #666666;
				}
			}
		}

		.total {
			height: 44px;
			display: flex;
			justify-content: space-between;
			align-items: center;

			span {
				font-size: 15px;
				font-weight: bold;
				color: #333333;
			}

			.price {
				font-weight: 400;
				color: #0f114a;
			}
		}

		.save {
			width: 230px;
			height: 44px;
			line-height: 44px;
			background: #0f114a;
			opacity: 1;
			border-radius: 2px;
			text-align: center;
			font-size: 16px;
			font-weight: bold;
			color: #edd4ac;
			margin-top: 30px;
			cursor: pointer;
			margin-bottom: 20px;
		}
	}

	.select-active {
		position: relative;
	}

	.select-active:after {
		background-image: url("../../../assets/images/design/select@2x.png");
		background-size: 100%;
		width: 13px;
		height: 13px;
		position: absolute;
		right: 5px;
		top: 5px;
		content: "";
	}

	.table-wrap {

		.input-box {
			width: 166px;
			height: 60px;
			float: left;
			display: flex;
			align-items: center;
			padding: 20px 10px;

			.input-title {
				width: 42px;
				font-size: 14px;
				font-weight: bold;
				color: #000000;
			}

			.input {
				width: 80px;
				height: 22px;
				background: #FFFFFF;
				border: 1px solid #DDDDDD;
				margin-left: 10px;
				text-align: center;
			}
		}
	}

	.upload-list {
		display: inline-block;
		margin-right: 10px;

		.profile-image-wrap {
			display: inline-block;
			position: relative;
			.profile-image-icon {
				position: absolute;
				top: -10px;
				right: 0;
				font-size: 20px;
				z-index: 100;
			}
		}

		img {
			margin: 0 10px;
		}
	}
</style>
